import type { GiftCardListParams } from '../api/gift-cards-api';

/** Store-scoped keys: switching stores never shares cache. */
export const giftCardKeys = {
  all: (storeId: string) => ['stores', storeId, 'gift-cards'] as const,
  lists: (storeId: string) => [...giftCardKeys.all(storeId), 'list'] as const,
  list: (storeId: string, params: GiftCardListParams) =>
    [...giftCardKeys.lists(storeId), params] as const,
  details: (storeId: string) => [...giftCardKeys.all(storeId), 'detail'] as const,
  detail: (storeId: string, id: string) => [...giftCardKeys.details(storeId), id] as const,
  transactions: (storeId: string, id: string) =>
    [...giftCardKeys.detail(storeId, id), 'transactions'] as const,
};
